import { gql, useQuery } from '@apollo/client';
import { Button, Stack, Text, VStack } from '@chakra-ui/react';
import dayjs from 'dayjs';
import NextLink from 'next/link';
import * as React from 'react';

import { DateWindowType } from '@/graphql-types/globalTypes';
import { Card } from '@/imports/ui/chakra/components/Card';

import {
  UpcomingEvents_Events,
  UpcomingEvents_EventsVariables,
} from './graphql-types/UpcomingEvents_Events';

import { UpcomingEvent } from '../UpcomingEvent/UpcomingEvent';

const UPCOMING_EVENTS = gql`
  query UpcomingEvents_Events($input: EventsInput!) {
    events(input: $input) {
      results {
        _id
        ...UpcomingEvent_EventFragment
      }
    }
  }
  ${UpcomingEvent.eventFragment}
`;

export const UpcomingEvents = () => {
  const query = useQuery<UpcomingEvents_Events, UpcomingEvents_EventsVariables>(
    UPCOMING_EVENTS,
    {
      variables: {
        input: {
          limit: 3,
          offset: 0,
          filter: {
            dateWindow: {
              windowType: DateWindowType.AnyOverlap,
              windowStart: dayjs().startOf('day').toISOString(),
            },
          },
        },
      },
    }
  );

  const events = query.data?.events.results;

  if (!events?.length) {
    return null;
  }

  return (
    <Card>
      <Stack spacing="4" p="4">
        <Text color="gray.600" textStyle="compactStrong">
          UPCOMING EVENTS
        </Text>
        {events.map((result) => (
          <UpcomingEvent key={result._id} event={result} />
        ))}
        <NextLink href="/events">
          <Button variant="outline" colorScheme="gray" w="full">
            See All
          </Button>
        </NextLink>
      </Stack>
    </Card>
  );
};
